module.exports = __webpack_public_path__ + "static/media/domarutbildning.3721b8f1.jpg";